import React from 'react';
import { applySizeToProps } from '../utils/applySizeToProps';
import { IconProps } from '../types';

export const IconReturnOutline: React.FC<IconProps> = (props) => (
  <svg {...applySizeToProps(props)} xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" viewBox="0 0 24 24"><path fill="currentColor" fillRule="nonzero" d="M23.802 0v16L2.25 15.999l6.919 7.027a.58.58 0 0 1 .065.728l-.065.079a.555.555 0 0 1-.717.066l-.077-.066L0 15.327l8.363-8.493a.555.555 0 0 1 .794 0 .58.58 0 0 1 .065.727l-.065.08-7.144 7.256h20.705V1.103H11.901a.552.552 0 1 1 0-1.103z" /></svg>
);
